const debug = true;
export default {
    // url:'https://quanzi.lnkj6.com/api/'
    url: 'https://shequan.zhihuiyun123.com/api/'
}